export const BanquetSeatingIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="24" height="24" rx="6" fill="url(#pattern0_8315_4772)" />
      <defs>
        <pattern
          id="pattern0_8315_4772"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_8315_4772" transform="scale(0.0434783)" />
        </pattern>
        <image
          id="image0_8315_4772"
          width="23"
          height="23"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAIAAABvSEP3AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAwtJREFUeNqklUsorGEYx30XhhkhieQSZVw2QrJAiKJh4XTOggUrC2LBysbeUkqykI1yKxFlYylCOmUxuSQLc9xi3C9z+WaG35n3NMYwc07Os5jeed7n+b/P//887/tJ37/9sPyyhL28hH3NJMntcqvPtidFlV++iiJJkqY5VUVWPB5PMBS27Ha7LMuRkZHBUMiVQ5zDtqqqJpOppKTE5XKFiFQ/ujicEiIiIpxOZ2dnZ1dXl6ZpLDY2NhRFYa3T6Vj4pwTWQlBFRUVHR0dycjLr1NRUnOHh4QkJCYDirK6ujo2NdbvdQWshLisra3BwkLTCwsL29vbh4eG7u7ubm5vl5eWkpKShoSECVlZWenp64IsoQRkJpSGFFvf397Ozs5rXIJKZmclWeno6er/TuMHUcGG98GUSXVpampubu7CwUFRU1N3dnZaWhn97e7u/vz8nJ6eqqmpqampraysqKkr0yGF3vKFAlY5ER0efnp5CraamZnR01P/Ak5OT5ubm8/PzuLg4g8Fwe3sLcYHypzAg2BgYGJienm5rawOutbU1gGlKSkptbS2kJicnZ2ZmkNnhcLzrEUQyMjLKy8sTExMbGxtFUz5KRneKi4uNRiNK19XVkfUOhek4PDxcWlrid2JiAkZnZ2cfUa6urtbW1jY3Nw8ODubn58kKVNfjNTS7vr4WGo+NjfniMDJbWlqsVqter4c+w+nTRck2Zj89Pwm1MZvNVlBQUFlZ+dNrqIDe8F9dXe3r68vLy0Ovx8dHlBYHSOJO+xfMgKDOyMhITEwMtdBmio+Pj6c0SkBd5KeQsrKypqYmCvdNjRwwb4wWEKxRl04B2tvby4XASdrDwwNb9Ji1b3CxN0a//yjK5eWlxWJBGkQ5Pj6GRX19fX5+Ps719XVmb3d3d3x8HFLiQn7CSFy8xcXFubk5ndd2dnZAoYSjoyOemL29PbPZjCKU+ZeXQYy2IMh07e/vcyFpEKBiJv7pfQl4xxAYFT9NfkPRXC6CQry7NCX0SZIsqfTCbrP9xycgTJHVVwEGAEpgr9S/7JBrAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  );
};
